export default "__VITE_ASSET__699a24ea__"